import { useQuery } from '@apollo/client';
import { CKContainerProps, CKLayoutGrid } from 'clearkit';

import { PageLayout } from '~/components/unified/PageLayout';

import { WhenTargetMarkets } from '../policies/WhenTargetMarkets';
import { useTargetMarket } from './hooks/useTargetMarket';
import TargetMarketCompaniesQuery from './queries/TargetMarketCompanies.graphql';
import { Sidebar } from './Sidebar';

const PageWrapper = ({ children, ...rest }: CKContainerProps) => (
  <PageLayout {...rest} className="@container/list">
    {children}
  </PageLayout>
);

const TargetMarketCompanies = ({ search }: any) => {
  const { data } = useQuery(TargetMarketCompaniesQuery, {
    skip: !search,
    variables: {
      country: search?.country || [],
      description: search?.description || [],
      employees: search?.employees || [],
      industry: search?.industry || [],
      raised: search?.raised || [],
      tag: search?.tag || [],
      tech: search?.tech || [],
      type: search?.type || [],
      page: 1,
    },
  });

  const companies = data?.targetMarketCompanies?.companies || [];
  const total = data?.targetMarketCompanies?.total || 0;

  return (
    <PageWrapper>
      <PageLayout.Body>
        <PageLayout.Content className="min-h-full space-y-4">
          <p>Total Companies {total}</p>
          <CKLayoutGrid
            className="w-full"
            gap="0"
            gridTemplateColumns="repeat(auto-fit, minmax(250px, 1fr))"
          >
            {companies.map((company: any) => (
              <div key={company.id}>{company.name}</div>
            ))}
          </CKLayoutGrid>
        </PageLayout.Content>
      </PageLayout.Body>
    </PageWrapper>
  );
};

const TargetMarketsPage = () => {
  const { search, setSearch, id, dirty, setTargetMarket } = useTargetMarket();

  return (
    <WhenTargetMarkets cta={'CTA'}>
      <CKLayoutGrid className="w-full" gap="0" gridTemplateColumns="auto 1fr">
        <Sidebar
          dirty={dirty}
          id={id}
          search={search}
          setSearch={setSearch}
          setTargetMarket={setTargetMarket}
        />
        <TargetMarketCompanies search={search} />
      </CKLayoutGrid>
    </WhenTargetMarkets>
  );
};

export { TargetMarketsPage };
